import { IBarPoints, XScale, YScale } from '../interfaces/barGraph';
import { area, curveNatural } from 'd3';

export class AreaGraph {
  constructor(
    private svgContainer: any,
    private data: IBarPoints,
    private xScale: XScale,
    private yScale: YScale,
    private yMin: any,
    private isDarkMode: boolean
  ) {
    this.drawArea();
  }

  updateAreaGraph(currentData, xScale, yScale, yMin, isDarkMode) {
    this.data = currentData;
    this.xScale = xScale;
    this.yScale = yScale;
    this.yMin = yMin;
    this.isDarkMode = isDarkMode;

    this.drawArea();
  }

  drawArea(): void {
    let selection = this.svgContainer.select('path.area-path');

    const filterNoRecords = this.data.filter(d => d.extra.areaMax !== 0);
    this.svgContainer.datum(filterNoRecords);

    if (selection.empty()) {
      selection = this.svgContainer.append('svg:path');
    }

    selection
      .attr('class', this._getAreaClass())
      .attr('d', this._getAreaGenerator());
  }

  private _getAreaClass() {
    return 'area-path ' + (this.isDarkMode ? 'area-dark' : 'area-light');
  }

  private _getAreaGenerator() {
    return area()
      .x((d: any) => this.xScale(d.name))
      .y0(this.yScale(this.yMin))
      .y1((d: any) => this.yScale(d.extra.areaMax))
      .curve(curveNatural);
  }
}
